import { services, achievements } from '~/data/siteData'
import { ServicesSection, AchievementsSection } from '~/components/Sections'

export default function ServicesPage() {
  return (
    <main>
      <section className="page-hero section-pad muted">
        <div className="container">
          <span className="eyebrow">What We Offer</span>
          <h1 className="page-hero-title">Machines, Inks &amp; Complete Support</h1>
          <p className="page-hero-desc">
            From VICTORY digital printers to VisionJet consumables, installation,
            and annual maintenance — everything under one roof.
          </p>
        </div>
      </section>
      <ServicesSection items={services} />
      <AchievementsSection items={achievements} />
    </main>
  )
}
